export default "__VITE_ASSET__LroKtEFc__"